export interface OrganisationOverview {
  id: string
  name: string
  key: string
  parentLevel?: string | null
  levelType: string
  users: UserInfo[]
}
  
export interface UserInfo {
  id: string
  firstName: string
  lastName: string
  email: string
  createdAt: string
  hasCompleted?: boolean
  avatarUrl?: string
}

// Performance Review Enums
export enum AssignmentType {
  TEAM = 'team',
  ROLE = 'role',
  INDIVIDUAL = 'individual',
}

export enum QuestionType {
  SLIDER = 'slider',
  TEXT_INPUT = 'text_input',
  TEXTAREA = 'textarea',
  RATING = 'rating',
  MULTIPLE_CHOICE = 'multiple_choice',
}

export interface QuestionMetadata {
  min?: number
  max?: number
  options?: Array<{ id: string; value: string }> | string[]
}

// Performance Review DTOs
export interface CreateQuestionDto {
  questionText: string
  questionType: QuestionType
  order?: number
  isRequired?: boolean
  metadata?: QuestionMetadata
}

export interface CreateAssignmentDto {
  type: AssignmentType
  targetId: string
}

export interface CreateTemplateDto {
  name: string
  description?: string
  dueDate?: string
  assignments: CreateAssignmentDto[]
  questions: CreateQuestionDto[]
}

export interface UpdateTemplateDto {
  name?: string
  description?: string
  dueDate?: string
  questions?: CreateQuestionDto[]
  isActive?: boolean
}

export interface CreateResponseDto {
  templateId: string
  questionId: string
  userId: string
  responseValue: string
}

export interface UpdateResponseDto {
  responseValue: string
}

export interface ResponseSubmission {
  questionId: string
  responseValue: string
}

export interface SubmitResponsesDto {
  templateId: string
  responses: ResponseSubmission[]
}

// Performance Review Entities
export interface PerformanceReviewAssignment {
  type: AssignmentType
  targetId: string
}

export interface PerformanceReviewTemplate {
  id: string
  name: string
  description?: string
  organisation: string
  assignments: PerformanceReviewAssignment[]
  participants: PerformanceReviewParticipantDto[]
  dueDate?: string
  isActive: boolean
  completionRate?: number
  createdBy: string
  createdAt: string
  updatedAt: string
  questions?: PerformanceReviewQuestion[]
  responses?: PerformanceReviewResponse[]
}

export interface PerformanceReviewQuestion {
  id: string
  template: string
  questionText: string
  questionType: QuestionType
  order: number
  isRequired: boolean
  metadata?: QuestionMetadata
  createdAt: string
  updatedAt: string
}

export interface PerformanceReviewResponse {
  id: string
  template: string
  question: string | PerformanceReviewQuestion
  user: string
  responseValue: string
  createdAt: string
  updatedAt: string
}

export interface PerformanceReviewComment {
  content: string
}

export interface AnswerComment {
  questionId: string
  content: string
}

export interface PerformanceReviewParticipantDto {
  id: string
  avatarUrl?: string
}

export interface PerformanceReviewInsightsDto {
  dueDate?: string
  completionRate: number
  completedUsers: number
  totalUsers: number
}
